import React from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import HubSpotContactForm from "./forms/HubSpotContactForm";
import "./ContactPage.css";

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="contact-page">
      <Header />
      <div className="contact-content">
        <div className="container">
          <div className="page-header">
            <h1 className="page-title">{t("contact.title")}</h1>
            <p className="page-description">
              {t("contact.description")}
            </p>
          </div>

          <div className="contact-sections">
            <div className="contact-form-section">
              <div className="section-card">
                <h2 className="section-title">{t("contact.sendMessage")}</h2>
                <HubSpotContactForm />
              </div>
            </div>

            <div className="contact-info-section">
              <div className="section-card">
                <h2 className="section-title">
                  {t("contact.additionalInfo")}
                </h2>
                <div className="contact-details">
                  <div className="contact-item">
                    <div className="contact-icon">📧</div>
                    <div className="contact-text">
                      <strong>{t("contact.email")}:</strong>
                      <a href="mailto:support@gesslargardens.com">
                        support@gesslargardens.com
                      </a>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">📞</div>
                    <div className="contact-text">
                      <strong>{t("contact.phone")}:</strong>
                      <a href="tel:+15551234567">(555) 123-4567</a>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">🕒</div>
                    <div className="contact-text">
                      <strong>{t("contact.hours")}:</strong>
                      {t("contact.hoursValue")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="section-card">
                <h2 className="section-title">{t("contact.quickLinks")}</h2>
                <div className="quick-links">
                  <a href="/privacy" className="quick-link">
                    <div className="quick-link-icon">🔒</div>
                    <div className="quick-link-text">
                      <strong>{t("contact.privacyPolicy")}</strong>
                      <span>{t("contact.readPrivacyPolicy")}</span>
                    </div>
                  </a>
                  <a href="/terms" className="quick-link">
                    <div className="quick-link-icon">📋</div>
                    <div className="quick-link-text">
                      <strong>{t("contact.termsOfService")}</strong>
                      <span>{t("contact.readTerms")}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
